import { render, staticRenderFns } from "./DiscountViewSidebar.vue?vue&type=template&id=54ac9e4c&scoped=true&"
import script from "./DiscountViewSidebar.vue?vue&type=script&lang=js&"
export * from "./DiscountViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DiscountViewSidebar.vue?vue&type=style&index=0&id=54ac9e4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ac9e4c",
  null
  
)

export default component.exports